module.exports = __webpack_public_path__ + "static/media/revenue_ops_use_case_2.7a96616d.svg";